import { Card } from '@blueprintjs/core';
import * as React from 'react';
import { Body } from 'vet-bones/design-system/components';

import {
  DASHBOARD_COMMUNITY,
  DASHBOARD_DOCS,
  DASHBOARD_KNOWLEDGE_KITS,
  DASHBOARD_TRAININGS,
} from 'src/ui/constants/testIds';
import communityIcon from 'src/ui/templates/images/community.svg';
import docsIcon from 'src/ui/templates/images/docs.svg';
import knowledgeKitIcon from 'src/ui/templates/images/knowledgeKits.svg';
import trainingsIcon from 'src/ui/templates/images/trainings.svg';
import { openApplicationInTab } from 'src/ui/utils/window';

type Widget = {
  title: string;
  link: string;
  icon: string;
  testId: string;
};
export const WIDGETS: Widget[] = [
  {
    title: 'Knowledge Kits',
    link: '/kits',
    icon: knowledgeKitIcon,
    testId: DASHBOARD_KNOWLEDGE_KITS,
  },
  {
    title: 'Docs',
    link: 'https://docs.stardog.com/',
    icon: docsIcon,
    testId: DASHBOARD_DOCS,
  },
  {
    title: 'Trainings',
    link: 'https://academy.stardog.com/learn',
    icon: trainingsIcon,
    testId: DASHBOARD_TRAININGS,
  },
  {
    title: 'Community',
    link: 'https://community.stardog.com/',
    icon: communityIcon,
    testId: DASHBOARD_COMMUNITY,
  },
];

export const Widgets: React.FC = () => (
  <>
    {WIDGETS.map((widget) => (
      <Card
        key={widget.title}
        className="widget-card"
        data-testid={widget.testId}
        interactive
        onClick={() => openApplicationInTab(widget.link)}
      >
        <img alt={widget.title} className="widget-icon" src={widget.icon} />
        <Body size="md" weight="semibold">
          {widget.title}
        </Body>
      </Card>
    ))}
  </>
);
